import { fileTypeFromBuffer } from 'file-type'

import { kmlFileToGeoJSON, shpFilesToGeoJSON } from '@/utils/file-conversions'
import {
  getInfosFromGeoJSON,
  getTiffParameters,
} from '@/utils/tiff-manipulations'

export async function validatePerimetersFiles(files: File[]) {
  const possibleShpExtensions = ['shp', 'dbf', 'cpg', 'prj', 'shx']
  const possibleKmlExtensions = ['kml']

  const { shpFiles, kmlFile } = files.reduce(
    (acc, file) => {
      const fileExtension = file.name.split('.')[1]

      const isShp = possibleShpExtensions.some(
        (possibleExtension) => possibleExtension === fileExtension,
      )
      if (isShp) return { ...acc, shpFiles: [...acc.shpFiles, file] }

      const isKml = possibleKmlExtensions.some(
        (possibleExtension) => possibleExtension === fileExtension,
      )
      if (isKml) return { ...acc, kmlFile: file }

      return acc
    },
    {
      shpFiles: [] as File[],
      kmlFile: null as File | null,
    },
  )

  if (!shpFiles.length && !kmlFile) throw new Error('Perímetro inválido')

  const geojson = kmlFile
    ? await kmlFileToGeoJSON(kmlFile)
    : await shpFilesToGeoJSON(shpFiles)

  if (geojson instanceof Array) {
    throw new Error('Mais de um perímetro selecionado.')
  }

  const { bounds, filename, interestArea } = await getInfosFromGeoJSON(geojson)

  const isAllUnique = _checksIfExtensionsAreUnique(files, filename)
  if (!isAllUnique && !kmlFile) throw new Error('Existem extensões repetidas.')

  return { geojson, bounds, filename, interestArea }
}

export const validateMosaicFile = async (
  file: File,
  min: number,
  max: number,
) => {
  const { gsd, coord_x, coord_y, px_res } = await getTiffParameters(file)

  if (gsd < min || gsd > max)
    throw new Error(
      `O GSD do mosaico está fora do padrão aceitável pela Cromai. (GSD = ${gsd}; intervalo ideal ${min} < GSD < ${max})`,
    )

  return { gsd, coord_x, coord_y, px_res }
}

const _shapefileList = ['.shp', '.shx', '.dbf', '.prj', '.cpg']

const _checksIfExtensionsAreUnique = (files: File[], basename: string) => {
  const baseList = _shapefileList.map((ext: string) => basename.concat(ext))

  return files.every((file) => baseList.includes(file.name))
}

export async function checkImageIntegrity(file: File) {
  const filesTypes = ['image/jpeg', 'image/jpg', 'image/png']
  const type = await fileTypeFromBuffer(await file.slice(0, 16).arrayBuffer())

  if (!type || !filesTypes.includes(type.mime))
    throw new Error('Imagem inválida')
}
